import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackNewShippingInfoSetParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/account/trackNewShippingInfoSet";

const useTrackNewShippingInfoSet = (
    parameters: TrackNewShippingInfoSetParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.newShippingInfoSet, parameters, options);
};

export default useTrackNewShippingInfoSet;
